"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useToast = void 0;

var _react = require("react");

var _ToastContextProvider = require("./ToastContextProvider");

var useToast = function useToast() {
  var context = (0, _react.useContext)(_ToastContextProvider.ToastContext);

  if (!context) {
    throw new Error("useToast must be used within a ToastContextProvider");
  }

  return {
    add: context.add,
    remove: context.remove
  };
};

exports.useToast = useToast;